function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M18.75 14.004l-4.787.957m.475-5.43l-2.26.955a1.42 1.42 0 01-1.122-.016 1.478 1.478 0 01-.781-.83 1.525 1.525 0 01.706-1.9l2.259-1.127a1.961 1.961 0 011.594-.094l4.639 1.828",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.2 15h1.6l3.049 2.326a.83.83 0 001.15.09l4.26-3.518a.842.842 0 00.129-1.164l-2.347-2.609M10.736 7.9l-.247-.2a1.787 1.787 0 00-1.725-.221L5.194 9",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M1.39 15.75h2.66a1.141 1.141 0 001.2-1.072V9.321a1.141 1.141 0 00-1.2-1.071H1.39m21.22 7.5h-2.66a1.141 1.141 0 01-1.2-1.072V9.321a1.141 1.141 0 011.2-1.071h2.66",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M.75 12a11.25 11.25 0 1022.5 0 11.25 11.25 0 10-22.5 0z",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

function SvgBusinessDealHandshakeCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgBusinessDealHandshakeCircle;